// @ constants
const {
    ADD_DOCUMENTATION_BUTTON,
    CARD_DESIGN,
    INTERVENER_TYPE,
} = require('constants/index');

module.exports = {
    title: 'contractSummary-checkingAccountTitle',
    accountNumber: 'contractSummary-accountNumber',
    backButtonText: 'contractSummary-backTextAccount',
    backButtonUrl: '/myprofile/accounts',
    setSuccessStepPrefix: 'checkingAccount_setSuccessStepPrefix',
    instructions: 'checkingPayrollAccount_instructions',
    details: [
        [
            {
                columns: 12,
                details: [
                    {
                        columns: 5,
                        type: CARD_DESIGN,
                    },
                    {
                        columns: 7,
                        interveners: [],
                        title: 'contractsView-interveners',
                        type: INTERVENER_TYPE,
                    },
                    {
                        columns: 7,
                        type: ADD_DOCUMENTATION_BUTTON,
                    }
                ]
            }
        ]
    ],
    warningMessage: [
        [
            {
                text: 'contractSummary-checkingAccountSuccessCheckInfo'
            }
        ]
    ],
    successWithEmail_warningMessage: [
        [
            {
                text: 'contractSummary-checkingAccountSuccessStepEmail'
            }
        ]
    ],
    successWithEmailWithOneHolder_warningMessage: [
        [
            {
                text: 'contractSummary-checkingAccountSuccessStepEmailWithOneHolder'
            }
        ]
    ]
}
